<template>
    <div class="header" v-if="headerData">
        <div class="pc_header">
            <div class="header-con">
                <div class="wrap">
                    <a href="./index.php"><img class="logo" :src="headerData.logo"></a>
                    <div class="menus">
                        <ul class="ul">
                            <li class="li" :class="isNavCurrent == index ? 'active' : ''" v-for="(item, index) in headerData.menus" :key="index">
                                <div class="link" @click="toHref(item, index)">{{ item.title }}</div>
                                <div class="dl" v-if="item.children">
                                    <div class="small_menu clearfix">
                                        <div class="amitem" :class="childNavCurrent == index2 ? 'active' : ''" v-for="(item2, index2) in item.children" :key="index2" @click="toHref2(item2, index2, index)">{{ item2.title }}</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
        <!-- 手机菜单 -->
        <div class="wap_header">
            <div class="header_nav">
                <a href="./index.php"><img class="logo" :src="headerData.logo" /></a>
                <div class="menu" @click="menuOpenClick"></div>
            </div>
            <div class="listBox" v-if="webMenu">
                <div class="menuList">
                    <div class="close" @click="menuCloseClick"></div>
                    <ul class="menu_ul">
                        <li class="menu_li" v-for="(item, index)  in headerData.menus">
                            <div class="menu_li_span ">
                                <div class="txt" @click="toHref(item, index)">{{ item.title }}</div>
                            </div>
                            <ul class="son" v-if="item.children">
                                <li class="son_li" v-for="(el, index2 ) in item.children">
                                    <div class="txt" @click="toHref2(el, index2, index)">{{ el.title }}
                                    </div>
                                </li>

                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: "Header",
    components: {
    },
    props: ["isNavCurrent", "childNavCurrent"],

    data() {
        return {
            isPc: true,
            isNavActive: 1,
            webMenu: false,
            headerData: null,
        };
    },
    async created() {
        // 测试环境
        if (window.location.href.indexOf('localhost') >= 0) {
            var res = await this.$post('/test/getPage', { id: 9 });
            this.headerData = res.data;
        } else {
            this.headerData = orginalJsonData.header;
        }
    },
    mounted() {
        var that = this;
        this.$(window).on('resize', function () {
            that.resizeWindow();
        });
        this.resizeWindow();
        window.addEventListener("scroll", this.pageScoll);
    },
    methods: {
        resizeWindow() {
            var w = this.$(window).width();
            if (w > 768) {
                this.isPc = true;
            } else {
                this.isPc = false;
            }
        },
        pageScoll() {
            if (!this.isPc) {
                var ua = navigator.userAgent.toLowerCase();
                var scrollTop = $(window).scrollTop();
                if (scrollTop > 100) {
                    this.$emit('videoShowF', false)
                } else {
                    this.$emit('videoShowF', true)
                }
            }

        },
        menuCloseClick() {
            this.webMenu = false
            this.$emit('videoShowF', true)
        },
        menuOpenClick() {
            this.webMenu = true
            this.$emit('videoShowF', false)
            console.log('ref');
        },
        toHref(item, idx) {
            window.location.href = item.url;
        },
        toHref2(item, idx, parent_index) {
            window.location.href = item.url;
        }
    },
};
</script>
<style scoped>
.header {
    width: 100%;
    background-color: #fff;
    position: relative;
    z-index: 300;
    min-width: 1080px;
}

.header .wap_header {
    display: none;
}

.header .pc_header {
    display: block;
    height: 0.8rem;
}

.header .header-con {
    width: 100%;
    height: 0.8rem;
    background-color: #fff;
    position: fixed;
    z-index: 3000;
    box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
}

.header .header-con .wrap {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.header .header-con.active {
    /* background: #fff url(../images/common/header_bg.png) repeat-x; */
}

.header .logo {
    width: 1.4rem;
    margin-left: .66rem;
}

.header .menus {
    width: 10.80rem;
    height: 100%;
}

.header .menus .ul {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.header .menus .li {
    display: block;
    width: 16.666%;
    text-align: center;
    height: 100%;
    position: relative;
}

.header .menus .li .link {
    font-size: 0.18rem;
    color: #212121;
    margin: 0px auto;
    line-height: 0.8rem;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    padding: 0px 0.1rem;
    cursor: pointer;
    font-weight: 800;
    position: relative;
}

.header a:link {
    color: rgba(255, 255, 255, 0.6)
}

.header a:visited {
    /* 更改文字属性 */
    color: rgba(255, 255, 255, 0.6)
}

.header a:active {
    /* 更改文字属性 */
    color: rgba(255, 255, 255, 0.6)
}

.header a:hover {
    /* 设置文字属性 */
    color: rgba(255, 255, 255, 0.6)
}

.header .menus .li:hover .link::after,
.header .menus .li.active .link::after {
    content: '';
    width: 100%;
    height: .05rem;
    background: #ce2520;
    position: absolute;
    left: 0;
    bottom: 0;
}

.header .menus .li:hover .link,
.header .menus .li.active .link {
    color: #ce2520;
}

.header .menus .li:hover .dl {
    display: block;
}

.header .menus .li .dl {
    display: none;
    width: 47%;
    height: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -0.04rem;
    margin-top: 0.83rem;
    background-color: #fff;
    text-align: center;
}

.header .menus .li .dl .small_menu {
    margin: 0px auto;
    width: 100%;
}

.header .menus .li .dl .small_menu .amitem {
    height: .44rem;
    line-height: 0.44rem;
    font-size: 0.14rem;
    color: #000000;
    cursor: pointer;
    width: 100%;
    background: #ffffff;
    border-bottom: .02rem solid #eee;
}

.header .menus .li .dl .small_menu .amitem:hover,
.header .menus .li .dl .small_menu .amitem.active {
    color: #ffffff;
    background: #b7211c;
}


.header .menus .li .dl .small_menu.menu0 .item {
    display: block;
    float: left;
    width: 20%;
    float: left;
    position: relative;
}

@media screen and (max-width: 768px) {
    .header {
        width: 100%;
        min-width: 3rem;

    }

    .header .pc_header {
        display: none;
    }

    .header .wap_header {
        display: block;
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
    }

    .header .header_nav {
        margin: 0 auto;
        display: flex;
        align-items: center;
        width: 85.3%;
        height: 0.9rem;
        justify-content: space-between;
    }

    .header .wap_header .logo {
        margin: 0rem;
        width: 1.44rem;
        height: 0.38rem;
        background: url(../assets/common/logo_wap.png) no-repeat;
        background-size: 100% 100%;
    }

    .header .wap_header .menu {
        width: 0.61rem;
        height: 0.61rem;
        background: url(../assets/common/menu.png) no-repeat;
        background-size: 100% 100%;
    }

    .header .wap_header .menuList {
        width: 3rem;
        height: 100%;
        background: #e60012;
        top: 0rem;
        align-self: self-end;
        position: absolute;
        right: 0rem;
        transition: all .5s;
        z-index: 99999;
    }

    .header .wap_header .listBox {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        position: fixed;
        z-index: 1000;
    }

    .header .wap_header .menuList .close {
        width: 0.61rem;
        height: 0.61rem;
        background: url(../assets/common/close.png) no-repeat;
        background-size: 100% 100%;
        margin-left: 1.85rem;
        margin-top: 0.15rem;
    }

    .header .wap_header .menuList .menu_ul {
        width: 100%;
    }

    .header .wap_header .menuList .menu_li {
        display: flex;
        align-items: center;
        flex-direction: column;

    }

    .header .wap_header .menuList .menu_li .menu_li_span {
        color: #fff;
        font-size: 0.3rem;
        position: relative;
        line-height: 1.06rem;
    }

    .header .wap_header .menuList .menu_li .menu_li_span::after {
        content: '';
        position: absolute;
        left: 50%;
        background: #fff;
        width: 0.4rem;
        height: 0.02rem;
        transform: translateX(-50%);

    }

    .header .wap_header .menuList .menu_li .son {
        width: 100%;
        margin-top: 0.4rem;
    }

    .header .wap_header .menuList .menu_li .son .son_li {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.26rem;
        margin-bottom: 0.5rem;
    }

}
</style>
